<template>
	<div class="top">
		<div class="subTitle">
			{{date}} {{weekName}} {{hour}}:{{minute.length===1 ? ('0' + minute):minute}}:{{second.length===1 ? ('0' + second):second}}
		</div>
		<div class="title">德育数据大屏</div>
		<div class="subTitle">温州市瓯海区</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				hour: '',
				minute: '',
				second: '',
				interval: null,
				date: '',
				weekName: '',
			}
		},
		created() {
			this.setDate()
			
			const {
				draw
			} = this
			
			this.interval = setInterval(draw, 1000)
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		methods: {
			draw() {
				let now = new Date();
				let hour = now.getHours();
				let minute = now.getMinutes();
				let second = now.getSeconds();
				this.hour = hour.toString()
				this.minute = minute.toString()
				this.second = second.toString()
				if((hour===24&&minute===0&&second===0) || (hour===12&&minute===0&&second===0)) {
					this.setDate()
				}
			},
			setDate() {
				let now = new Date();
				let mon = ['01','02','03','04','05','06','07','08','09',10,11,12]
				let date = ['01','02','03','04','05','06','07','08','09',10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
				this.date = now.getFullYear()+'-'+mon[now.getMonth()]+'-'+date[now.getDate() - 1]
				this.weekName = '星期' + "日一二三四五六".charAt(new Date().getDay())
				// console.log(this.date,this.weekName)
			}
		}
	}
</script>

<style lang="less" scoped>
	.top {
		height: 100%;
		padding: 0 20px 10px 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.title {
			font-size: 36px;
			width: 40%;
			text-align: center;
		}
		.subTitle {
			font-size: 24px;
			width: 30%;
			&:last-child {
				text-align: right;
			}
		}
	}
</style>
